import { Stack, Typography } from '@mui/material'
import { C1Tooltip } from 'c1ui'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { C1Icon } from 'components/core/icons/C1Icon'
import { differenceInDays } from 'date-fns'
import { Clock } from 'lucide-react'
import { Timestamp } from 'pbts/google/protobuf/timestamp'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getShortString } from '.'

export const LastLoginDisplay: FC<{ lastUsedAt?: Timestamp }> = ({ lastUsedAt }) => {
    if (!lastUsedAt) {
        return <C1EmptyIndicator />
    }

    const daysSinceLogin = differenceInDays(new Date(), Timestamp.toDate(lastUsedAt))

    const lastLoginTooltipMessage = (): React.ReactNode => {
        if (daysSinceLogin > 60) {
            return <FormattedMessage
                id="component_app_user_display_name_last_login_more_than_60_days_ago"
                defaultMessage="Last login was more than 60 days ago"
            />
        }
        if (daysSinceLogin > 30) {
            return <FormattedMessage
                id="component_app_user_display_name_last_login_more_than_30_days_ago"
                defaultMessage="Last login was more than 30 days ago"
            />
        }
        return <FormattedMessage
            id="component_app_user_display_name_last_login"
            defaultMessage="Last login was within the last 30 days"
        />
    }

    const getColor = (): string => {
        if (daysSinceLogin > 60) return 'error.main'
        if (daysSinceLogin > 30) return 'warning.main'
        return 'success.main'
    }

    return <Stack direction="row" spacing={1}>
        <Typography>{getShortString({ d: Timestamp.toDate(lastUsedAt), variant: 'date_only' })}</Typography>
        <C1Tooltip placement="bottom" title={lastLoginTooltipMessage()}>
            <C1Icon icon={Clock} sx={{ color: getColor() }} />
        </C1Tooltip>
    </Stack>
}
